export const insertStrefaKlienta = async (nav) => {
    await new Promise(r => setTimeout(r, 2));
    let navbar = document.querySelector(nav);
    if(navbar.querySelector(".navbar__items")){
        let link = document.createElement("a");
        if(siteId == 2){
            link.href=mainUrl+'/klienci';
            link.innerText = "Strefa klienta";
        }
        else {
            link.href=mainUrl+'/adwokaci-i-aplikanci';
            link.innerText = "Strefa adwokata / aplikanta";
        }
        link.classList.add("navbar__strefa");
        navbar.appendChild(link);
    }
 
 }
 